import { render } from "./BatchVitroPayDialog.vue?vue&type=template&id=11abe06f&scoped=true"
import script from "./BatchVitroPayDialog.vue?vue&type=script&lang=ts"
export * from "./BatchVitroPayDialog.vue?vue&type=script&lang=ts"

import "./BatchVitroPayDialog.vue?vue&type=style&index=0&id=11abe06f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-11abe06f"

export default script